module.exports = __webpack_public_path__ + "static/media/img007.5911c250.jpg";